import { render, staticRenderFns } from "./EditorSplit.vue?vue&type=template&id=33ceb506&"
import script from "./EditorSplit.vue?vue&type=script&lang=js&"
export * from "./EditorSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports